import './Strip.css';

export interface StripProps<Id extends string> {
  items: { id: Id; label: string }[];
  /** Omitted (rather than defaulted to the first item) when NONE of the
   *  chips represent the current screen — Today itself renders the
   *  Materials strip this way: tapping a chip enters the Materials
   *  workshop, but while still on Today none of them is "active". */
  activeId?: Id;
  onSelect: (id: Id) => void;
}

// THE universal secondary-nav pattern (p7-shell-locked): a scrollable,
// gold-highlighted chip strip that sits above the bottom nav for any tab
// with sub-views. Built once, used by four consumers — Auditions (a
// single-select STAGE filter), Projects (a single-select PHASE filter),
// Career (a section switch — Money/Documents/Development/Stats), and
// Today's Materials workshop (a section switch — This is me/Headshots/
// Resume/Reels). No prefix/section label is ever rendered here (locked
// hard rule: no instructional captions anywhere) — the chips speak for
// themselves, exactly as the blessed reference mock's `.subnav` does.
export function Strip<Id extends string>({ items, activeId, onSelect }: StripProps<Id>) {
  return (
    <div class="strip" role="tablist">
      {items.map((item) => (
        <button
          key={item.id}
          type="button"
          role="tab"
          aria-selected={item.id === activeId}
          class={`strip__chip${item.id === activeId ? ' strip__chip--active' : ''}`}
          onClick={() => onSelect(item.id)}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}
